module.exports = __webpack_public_path__ + "static/img/active-gateway.4aa7ebb.png";


//////////////////
// WEBPACK FOOTER
// ./src/apps/feelgrid/assets/markers/active-gateway.png
// module id = lR+7
// module chunks = 13